module.exports = __webpack_public_path__ + "static/media/reports_game-record.28e9ac24.svg";